const createBillingAddress = (payload, isOffline) => ({
  isSameAddress: !Boolean(payload.address),
  cep: payload.postcode,
  address: payload.address,
  neighborhood: payload.neighborhood,
  city: payload.city,
  state: payload.state,
  number: payload.number,
  noNumber: !Boolean(payload.number),
  complements: isOffline ? payload.complements : payload.complement,
  noComplement: !Boolean(
    (isOffline ? payload.complements : payload.complement).length
  ),
  addressNote: isOffline ? payload.address_note : payload.observation
})

export default {
  fillOfflineBillingAddress({ commit }, payload) {
    if (!payload) return
    commit("setBillingAddress", createBillingAddress(payload, true))
  },
  fillBillingAddress({ commit }, payload) {
    if (!payload) return
    commit("setBillingAddress", createBillingAddress(payload, false))
  }
}
